var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLogged
      ? _c("div", [
          _c(
            "div",
            {
              staticClass:
                "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
              style: {
                "background-image": "url(" + _vm.imagenFondo + ") !important"
              },
              attrs: { id: "page-login" }
            },
            [
              _vm.ingresoLogo
                ? _c("img", {
                    style: _vm.logoStyle,
                    attrs: {
                      src: _vm.ingresoLogo.imagen,
                      id: "logo",
                      alt: "logo"
                    }
                  })
                : _vm._e(),
              _vm.provider === "esign7"
                ? _c(
                    "b-card",
                    { staticClass: "text-center" },
                    [
                      _c("h5", { staticClass: "message my-5" }, [
                        _vm._v(
                          " No cierre la página mientras está en el proceso de enrolamiento "
                        )
                      ]),
                      _c("VerifyIdentityExternal")
                    ],
                    1
                  )
                : _vm._e(),
              _vm.provider === "signapi"
                ? _c(
                    "b-card",
                    { staticStyle: { "min-width": "450px" } },
                    [
                      _c("h5", { staticClass: "mb-4 text-center" }, [
                        _vm._v("Verificación de identidad")
                      ]),
                      _c("p", { staticClass: "text-muted text-center mb-4" }, [
                        _vm._v(
                          " Complete los datos para iniciar la verificación de identidad. "
                        )
                      ]),
                      _c("b-overlay", { attrs: { show: _vm.loading } }, [
                        _c("form", { attrs: { "data-vv-scope": "signapi" } }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 mt-2" },
                              [
                                _c("vs-input", {
                                  staticClass: "w-100 cursor-default",
                                  attrs: {
                                    autocomplete: "off",
                                    label: "RUT",
                                    name: "rut",
                                    value: _vm.jwtData.iut,
                                    readonly: ""
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12 mt-2" },
                              [
                                _c("vs-input", {
                                  staticClass: "w-100 cursor-default",
                                  attrs: {
                                    autocomplete: "off",
                                    label: "Nombre",
                                    name: "name",
                                    value: _vm.jwtData.name,
                                    readonly: ""
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12 mt-2" },
                              [
                                _c("vs-input", {
                                  staticClass: "w-100 cursor-default",
                                  attrs: {
                                    autocomplete: "off",
                                    label: "Correo",
                                    name: "email",
                                    value: _vm.jwtData.email,
                                    readonly: ""
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12 mt-2" },
                              [
                                _c("vs-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "w-100",
                                  attrs: {
                                    autocomplete: "off",
                                    label:
                                      "Número de serie del documento (carnet)",
                                    maxlength: "20",
                                    name: "serialNumber",
                                    placeholder: "Ej: 531417340",
                                    danger: _vm.errors.has(
                                      "signapi.serialNumber"
                                    ),
                                    "danger-text": _vm.errors.first(
                                      "signapi.serialNumber"
                                    )
                                  },
                                  model: {
                                    value: _vm.serialNumber,
                                    callback: function($$v) {
                                      _vm.serialNumber = $$v
                                    },
                                    expression: "serialNumber"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12 mt-2" },
                              [
                                _c("vs-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "w-100",
                                  attrs: {
                                    autocomplete: "off",
                                    label: "Comuna de residencia",
                                    maxlength: "100",
                                    name: "commune",
                                    placeholder: "Ej: Santiago",
                                    danger: _vm.errors.has("signapi.commune"),
                                    "danger-text": _vm.errors.first(
                                      "signapi.commune"
                                    )
                                  },
                                  model: {
                                    value: _vm.commune,
                                    callback: function($$v) {
                                      _vm.commune = $$v
                                    },
                                    expression: "commune"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "text-center mt-4" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    disabled: _vm.loading
                                  },
                                  on: { click: _vm.verifyWithSignApi }
                                },
                                [_vm._v(" Verificar identidad ")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }